import request from 'src/lib/data/request'
import { resolve } from 'url'
import config from 'config'

export default function graph(req, data, eid, ctx = {}) {
  let payload = {
    eid,
    data
  }

  let r = request(req, ctx).post(config.NEXT_PUBLIC_GRAPH_API_URL).send(payload)

  return r.then(res => {
    let { body } = res
    return res.body
  })
}
